import { controls } from "../../controls";
const rprbi4 = {
  label: "ACP NPA OUTSTANDING",
  starting: true,
  url: "ACP NPA OUTSTANDING",
  pageLabel: "ACP NPA OUTSTANDING",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.magicDateLabel({ tab: "filter", star: true, label: "From Date", width: "col-sm-2", target: "from_date" }),
    ...controls.magicDate({ tab: "filter", name: "from_date", width: "col-sm-2", dateType: "ontype", isRequired: true, default: "sd" }),

    ...controls.magicDateLabel({ tab: "filter", star: true, label: "As on Date", width: "col-sm-2", target: "as_on_date" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", isRequired: true, default: "sd" }),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "RBI ACP NPA OUTSTANDING",
    pdfProps: { pageSize: "A3", pageOrientation: "landscape" },
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    textReportProps: {
      'LBS': {
        filename: `RBI-ACP_NPA_OUTSTANDING-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },
    displayColumns: [
      {
        Header: "State Code",
        accessor: "state_code_RBI"
      },
      {
        Header: "District Code",
        accessor: "district_code_RBI",
      },
      {
        Header: "Block Code",
        accessor: "block_code",
      },
      {
        Header: "Farm Cr Count",
        id: "fcrcnt",
        formula: [{ f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'disb_count' }, { source: 'row', field: 'term_count' }, { source: 'row', field: 'allied_count' }] }]
      },
      {
        Header: "Farm Cr Amount",
        id: "fcramt",
        formula: [{ f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'croploan_amount' }, { source: 'row', field: 'farmterm_amount' }, { source: 'row', field: 'farmallied_amount' }] }]
      },
      {
        Header: "farmCr Crop Loan No.",
        accessor: "disb_count",
      },
      {
        Header: "farmCr Crop loan Amount",
        accessor: "croploan_amount",
      },
      {
        Header: "farmCr Term loan No.",
        accessor: "term_count",
      },
      {
        Header: "farmCr Term loan Amount",
        accessor: "farmterm_amount",
      },
      {
        Header: "Allied Count",
        accessor: "allied_count",
      },
      {
        Header: "Allied Amount",
        accessor: "farmallied_amount",
      },
      {
        Header: "Agri Infra No.",
        accessor: "infra_no",
      },
      {
        Header: "Agri Infra Amount",
        accessor: "infra_amt",
      },
      {
        Header: "Ancilllary Activities",
        accessor: "anc_count",
      },
      {
        Header: "Ancilllary Amount",
        accessor: "anc_amount",
      },
      {
        Header: "Micro Ent No.",
        accessor: "microent_no",
      },
      {
        Header: "Micro Ent Amount",
        accessor: "microent_amt",
      },
      {
        Header: "Small Ent No.",
        accessor: "smallent_no",
      },
      {
        Header: "Small Ent Amount",
        accessor: "smallent_amt",
      },
      {
        Header: "Medium Ent No.",
        accessor: "mediument_count",
      },
      {
        Header: "Medium Ent Amount",
        accessor: "mediument_amount",
      },
      {
        Header: "Khadi Count",
        accessor: "villageind_count",
      },
      {
        Header: "Khadi Amount",
        accessor: "villageind_amount",
      },
      {
        Header: "Other MSMEs No.",
        accessor: "msme_no",
      },
      {
        Header: "Other MSMEs Amount",
        accessor: "msme_amt",
      },
      {
        Header: "Export Cr. No.",
        accessor: "Expo_crno",
      },
      {
        Header: "Export Cr. Amount",
        accessor: "Expo_cramt",
      },
      {
        Header: "Education PS No.",
        accessor: "edu_psno",
      },
      {
        Header: "Education PS Amount",
        accessor: "edu_psamt",
      },
      {
        Header: "Housing PS No.",
        accessor: "housingps_count",
      },
      {
        Header: "Housing PS Amount",
        accessor: "housingps_amount",
      },
      {
        Header: "Social Infra No.",
        accessor: "social_infrano",
      },
      {
        Header: "Social Infra Amount",
        accessor: "social_infraamt",
      },
      {
        Header: "Renewable Energy No.",
        accessor: "renergy_no",
      },
      {
        Header: "Renewable Energy Amount",
        accessor: "renergy_amt",
      },
      {
        Header: "Other Proirity No.",
        accessor: "shg_count",
      },
      {
        Header: "Other Proirity Amount",
        accessor: "shg_amount",
      },
      {
        Header: "Loans weaker sec. PS No.",
        accessor: "weaker_psno",
      },
      {
        Header: "Loans weaker sec. PS Amount",
        accessor: "weaker_psamt",
      },
      {
        Header: "Agricultre NPS No.",
        accessor: "agri_npsno",
      },
      {
        Header: "Agricultre NPS Amount",
        accessor: "agri_npsamt",
      },
      {
        Header: "Education NPS No.",
        accessor: "edu_npsno",
      },
      {
        Header: "Education NPS Amount",
        accessor: "edu_npsamt",
      },
      {
        Header: "Housing NPS No.",
        accessor: "housing_npsno",
      },
      {
        Header: "Housing NPS Amount",
        accessor: "housing_npsamt",
      },
      {
        Header: "Personal Loan NPS No.",
        accessor: "personalnps_count",
      },
      {
        Header: "Personal NPS Amount",
        accessor: "personalnps_amount",
      },
      {
        Header: "Other NPS No.",
        accessor: "othernps_count",
      },
      {
        Header: "Other NPS Amount",
        accessor: "othernps_amount",
      },
    ]
  }
};
export default rprbi4;